/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
import cx from 'classnames';
import * as React from 'react';
import { useTheme } from '../utils/index.js';
import '@itwin/itwinui-css/css/tabs.css';
/**
 * Individual tab component to be used in the `labels` prop of `Tabs`.
 * @example
 * const tabs = [
 *   <Tab label='Label 1' sublabel='Description 1' />,
 *   <Tab label='Label 2' startIcon={<SvgPlaceholder />} />,
 * ];
 */
export const Tab = (props) => {
    const { label, sublabel, startIcon, children, className, ...rest } = props;
    useTheme();
    return (React.createElement("button", { className: cx('iui-tab', className), role: 'tab', tabIndex: -1, ...rest },
        startIcon &&
            React.cloneElement(startIcon, {
                className: 'iui-tab-icon',
                'aria-hidden': true,
            }),
        label && (React.createElement("span", { className: 'iui-tab-label' },
            React.createElement("div", null, label),
            sublabel && React.createElement("div", { className: 'iui-tab-description' }, sublabel))),
        children));
};
